import React from 'react'
import SelectBox from './select-box'
import Button from './button'
import styles from '../component-styles/calendar-kpis.module.scss'

interface KpiListProps {
  kpis: Kpi[]
  setSelected: (e: string) => void
}

const KpiList = React.memo(
  ({ kpis, setSelected }: KpiListProps): React.ReactElement => (
    <>
      {kpis.map(
        ({ metricID, displayName }: Kpi): React.ReactElement => (
          <Button
            key={metricID}
            onClick={(): void => setSelected(metricID)}
            type="selectBox"
          >
            {displayName}
          </Button>
        ),
      )}
    </>
  ),
  (prev, next): boolean => {
    // propsAreEqual function

    if (prev.kpis.length !== next.kpis.length) {
      return false
    }
    return true
  },
)

interface Props {
  kpis: Kpi[]
  selected: string
  setSelected: (e: string) => void
}

export default function KPIS({
  kpis,
  selected,
  setSelected,
}: Props): React.ReactElement {
  // TODO: metricID has been added
  // replace this with a simpleDrop down KpiList
  // make this work with metricID instead
  return (
    <div className={styles.container}>
      <h3>KPI Heatmaps</h3>
      <SelectBox value={selected}>
        <Button onClick={(): void => setSelected('None')} type="selectBox">
          None
        </Button>
        <KpiList kpis={kpis} setSelected={setSelected} />
      </SelectBox>
    </div>
  )
}
